import { useEffect, useState } from 'react'
import { useSceneStore } from '../../../../a.scenes/GameScene/store'
import { SEL_MANA_LEVEL_FOR_PLAYER } from '../../../../c.managers/LevelManager/selectors'

const ManaIndicator = () => {
  const { manaLevel, maxManaLevel } = useSceneStore(SEL_MANA_LEVEL_FOR_PLAYER)
  const [bars, setBars] = useState<number[]>()
  useEffect(() => {
    if (maxManaLevel) {
      const barUnits = maxManaLevel / 10

      // this should be something like this for 3 units
      // [33.3, 66.6, 100]
      // or for 4 units
      // [25, 50, 75, 100]
      // or for 5 units
      // [20, 40, 60, 80, 100]
      const breakValues = Array(barUnits)
        .fill(0)
        .map((_, idx) => (100 / barUnits) * (idx + 1))
      setBars(breakValues)
    }
  }, [maxManaLevel])
  const manaPerc = ((manaLevel ?? 0) / (maxManaLevel ?? 1)) * 100
  return (
    <div className="mana-indicator-container">
      <div className="mana-icon" data-ico="🍬"></div>
      <div className="mana-bar-container">
        {bars?.map((b, idx) => (
          <div key={`bar_${idx}`} className={`mana-bar-unit ${b <= manaPerc ? 'full' : ''}`} />
        ))}
        <div
          className="mana-bar-progress"
          style={{
            width: `${manaPerc}%`,
          }}
        />
      </div>
    </div>
  )
}
export default ManaIndicator
